module.exports = __webpack_public_path__ + "static/img/kv04.c0d6f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-2/kv04.jpg
// module id = nzaw
// module chunks = 0